<template>
  <div>
    <b-card
      no-body
      class="my-0"
      :class="{ 'card-transparent-background': type == 'register' }"
      ><b-card-header v-if="type == 'view'" class="card-header-profile-border">
        <b-row>
          <b-col> <h4>Order Numbeer</h4></b-col>
          <b-col class="text-right"
            ><h4 class="orderNumber">#{{ order_number }}</h4>
            <span :class="'orderStatusSpan ' + status + '_status'">{{
              status_str
            }}</span></b-col
          >
        </b-row>
      </b-card-header>

      <b-card-body
        class=""
        :class="{
          'p-2': type == 'profile' || type == 'edit',
          'py-0': type == 'register',
        }"
      >
        <div class="container">
          <b-row>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Location"
                label-for="dropoff_address"
                label-class="form-label-doorder"
              >
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ dropoff_address }}
                </span>
              </b-form-group>
            </b-col>

            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder form-group-datetime-doorder"
                label="Drivers within radius"
                label-for="fulfilment_date"
                label-class="form-label-doorder"
              >
                <template v-slot:label>
                  Drivers within radius
                  <span class="float-right font-weight-normal"
                    >{{ _circle_map_radius }} KM</span
                  >
                </template>

                <vue-slider
                  class="vue-slider-doorder"
                  v-model="_circle_map_radius"
                  :min="0"
                  :max="60"
                  :interval="1"
                  :dotSize="[30, 30]"
                  height="15px"
                ></vue-slider>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
    <b-card no-body class="my-3">
      <b-card-body
        class=""
        :class="{
          'p-2': type == 'profile' || type == 'edit',
          'py-0': type == 'register',
        }"
      >
        <SelectDriversTableForOrder
          ref="testtest"
          :drivers_list="drivers_list"
          :selectedDrivers.sync="selectedDrivers"
          :selectedDriversIndex.sync="selectedDriversIndex"
        />
        <b-row class="justify-content-center mt-2">
          <b-col lg="6" sm="6" class="px-md-1 text-center">
            <b-button
              variant="doorder-primary"
              class="btn-bumblebee btn-doorder mb-1 w-100"
             :disabled="!enable_assign"
              @click="clickAssignDrivers"
              >Assign Deliverer</b-button
            >
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- confirm assigned drivers Modal -->
    <b-modal
      id="confirm-selected-drivers-modal"
      modal-class="modal-doorder mt-0"
      scrollable
    >
      <div class="d-block mb-4">
        <p class="infoMessageModalP message-modal-doorder my-4">
          This deliverers are successfully selected <br />
          and ready to be assigned
        </p>
      </div>
      <b-row class="mb-4">
        <b-col lg="8" class="m-auto list-group-container">
          <b-list-group>
            <b-list-group-item
              class=""
              v-for="driver in selectedDriversObjs"
              :key="driver.id"
            >
              <b-row class="text-center">
                <b-col md="12"
                  ><span class="select-driver-name">
                    {{ driver.name }}
                  </span></b-col
                >
                <b-col md="12" class="">
                  <p class="select-driver-data">{{ driver.transport }}</p>
                  <p class="select-driver-data-dot">
                    <i class="fas fa-circle"></i>
                  </p>
                  <p class="select-driver-data-km">
                    {{ driver.driverkmaway }} KM away
                  </p>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group></b-col
        >
      </b-row>

      <template class="justify-content-center mt-5" #modal-footer>
        <b-row class="justify-content-center w-100">
          <b-col lg="3" md="6" class="text-center">
            <b-button
              v-if="!is_loading"
              variant="doorder-primary"
              class="btn-bumblebee btn-doorder btn-doorder-submit w-100"
              type="button"
              @click="confirmAssignDrivers"
            >
              Assign
            </b-button>
            <b-button
              type="button"
              disabled
              variant="doorder-primary"
              class="btn-bumblebee btn-doorder btn-doorder-submit w-100"
              v-else
            >
              <b-spinner
                small
                label="Small Spinner"
                variant="light"
              ></b-spinner>
              Loading</b-button
            >
          </b-col>

          <b-col lg="3" md="6" class="text-center">
            <b-button
              type="button"
              variant="doorder-danger-outline"
              class="btn-bumblebee btn-doorder btn-doorder-submit w-100"
              @click="closeModal"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";

import SelectDriversTableForOrder from "../tables_select/SelectDrivers.vue";

export default {
  name: "DriverDetailsAndAssign",
  components: { SelectDriversTableForOrder },
  props: [
    "type",
    "order_id",
    "order_number",
    "status_str",
    "status",
    "dropoff_address",
    "circle_map_radius",
    "drivers_list",
  ],
  data() {
    return {
      enable_assign: false,
      is_loading: false,
      selectedDrivers: [],
      selectedDriversIndex: [],
      selectedDriversObjs: [],
    };
  },
  beforeMount() {},
  mounted() {
    console.log(this.drivers_list);
  },
  computed: {
    _circle_map_radius: {
      get() {
        return this.circle_map_radius;
      },
      set(value) {
        this.$emit("update:circle_map_radius", value);
      },
    },
  },
  watch: {
    selectedDrivers(newval, oldval) {
      console.log(newval);
      console.log(oldval);
      if (newval.length > 0) {
        this.enable_assign = true;
      } else {
        this.enable_assign = false;
      }

      // this.$refs.testtest.getSelectedDrivers()
    },
  },
  methods: {
    clickAssignDrivers() {
      console.log(
        "in click submit assign drivers",
        this.order_id,
        this.selectedDrivers,
        this.selectedDriversIndex,
        this.selectedDriversObjs
      );
      console.log(this.drivers_list);
      this.selectedDriversObjs = [];
      for (let i = 0; i < this.selectedDriversIndex.length; i++) {
        let index = this.selectedDriversIndex[i];
        this.selectedDriversObjs.push(this.drivers_list[index]);
      }
      this.$root.$emit("bv::show::modal", "confirm-selected-drivers-modal");
    },
    closeModal() {
      this.$bvModal.hide("confirm-selected-drivers-modal");
    },
    confirmAssignDrivers() {
      console.log("in confirm assign drivers");
      console.log(this.order_id, this.selectedDrivers);
      this.is_loading = true;

      let formData = new FormData();
      formData.append("client", "DOORDER");
      // for(let i=0; i<this.selectedDrivers.length; i++){
      //   formData.append("operator_id[]", this.selectedDrivers[i])
      // }
      formData.append("operator_id", this.selectedDrivers[0]);

      let success_msg =
        "The order has been successfully assigned to " +
        this.drivers_list[this.selectedDriversIndex[0]].name;
      if (this.selectedDrivers.length > 1) {
        success_msg =
          "The accepted drivers have been notified about the order successfully";
      }

      this.is_loading = true;
      axios
        .post("jobs/job-action/" + this.order_id, formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: success_msg, //"Order is updated successfully ",
            type: "success",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {  
            this.is_loading = false;
            this.closeModal()
            this.$router.go();
          });
        
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error
              ? error.response.data.error
              : error.response.data.message,
            type: "error",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doorder/orders/order_details_components/DriverDetailsAndAssign.vue